/* eslint-disable */
class Timer {
  intervaltime = 0;
  num = 0;
  timeObj = null;
  /**
   * 
   * @param {intervaltime} 时间间隔 
   * @param {*} num 
   * @param {*} timerEvent 
   * @param {*} timerComplete 
   */
  constructor(intervaltime, num, timerEvent = null, timerComplete = null) {
    this.intervaltime = intervaltime;
    this.num = num;

    if (intervaltime == 0 || num == 0) {
      alert("时间间隔 或 次数 为0(未设置)")
      return;
    }
    //
    this.RunLogic(intervaltime, num, timerEvent, timerComplete)
  }

  //
  RunLogic(intervaltime, num, timerEvent, timerComplete) {
    this.timeObj = setTimeout(() => {
      if (num > 0) {
        num--;
        //console.log("计时次数", num);
        if (timerEvent) {
          timerEvent(num);
        }
        if (num == 0) {
          if (timerComplete) {
            timerComplete();
          }
          this.stop();
        }

        this.RunLogic(intervaltime, num, timerEvent, timerComplete);
      } else {

      }
    }, intervaltime);

  }

  //停止
  stop() {
    clearTimeout(this.timeObj)
  }

}
export default Timer;
